import { render, staticRenderFns } from "./salary Table.vue?vue&type=template&id=e71bab9c"
import script from "./salary Table.vue?vue&type=script&lang=js"
export * from "./salary Table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports